<template>
  <div>
    <div class="flex box">
      <div>
        <img src="@/assets/images/erro.svg">
        <p class="grey--text">
          404 - Página não encontrada.
        </p>
        
        <router-link :to="{ name: 'mainUser' }">
          Voltar para meu dados
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Page404",
};
</script>

<style lang="scss" scoped>
.flex {
  display: flex;
  justify-content: center;
}
.box {
  padding: 0.5rem;
  > div {
    min-width: 300px;
    margin: auto;
    text-align: center;
    > img {
      width: 250px;    
    }
  }
  p {
    font-size: 2rem;
  }
}
</style>